/**
 * The person at the screen changes: at logout, and when a login succeeds.
 *
 * Everything in the store was fetched for the session before and is dropped. Logging out only
 * took the token away, so the next person to log in in the same tab started with the lists the
 * last one had loaded, and kept any of them the server did not answer again.
 */
export const SESSION_ENDED = 'session/ended'

export const sessionEnded = () => ({ type: SESSION_ENDED })
